import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  CloseButton,
  HStack,
  ScaleFade,
  VStack,
} from "@chakra-ui/react";
import { useAlert } from "../../../hooks";
import React from "react";

const AlertContainer = () => {
  const { alertList, removeAlert } = useAlert();

  return (
    <VStack
      alignItems={"stretch"}
      position={"absolute"}
      width={"full"}
      zIndex={100}
    >
      {alertList.map((alert) => (
        <ScaleFade
          in={true}
          key={alert.uuid}
          style={{
            width: "full",
          }}
        >
          <Alert
            alignItems={"center"}
            borderRadius={"10px"}
            justifyContent={"space-between"}
            backgroundColor={
              alert.status === "error"
              ? "#E57672"
              : alert.status === "warning"
                ? "#F6CC62"
                : alert.status === "info"
                  ? "#8ED1EC"
                  : "#7CD5A8"
            }
            borderStyle={"solid"}
            borderWidth={"2px"}
            borderColor={
              alert.status === "error"
              ? "#E3453E"
              : alert.status === "warning"
                ? "#D69D0D"
                : alert.status === "info"
                  ? "#31A0C8"
                  : "#2AB66C"
            }
            status={alert.status}
            width={"full"}
          >
            <HStack justifyContent={"flex-start"}>
              <AlertIcon color={"white"} />
              <HStack alignItems={"flex-start"}>
                <AlertTitle>{alert.title}</AlertTitle>
                <AlertDescription>{alert.description}</AlertDescription>
              </HStack>
            </HStack>
            <CloseButton onClick={() => removeAlert(alert.uuid)} />
          </Alert>
        </ScaleFade>
      ))}
    </VStack>
  );
};

export default React.memo(AlertContainer);
